import { useState } from 'react';

import { Button, ButtonProps, Group, Popover, PopoverProps, Stack, Text } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';

type PopConfirmProps = {
	confirmText: string;
	onOk: () => void;
	onCancel: () => void;
	button: ButtonProps;
} & PopoverProps;
export const PopConfirm = ({ confirmText, onOk, onCancel, button, ...rest }: PopConfirmProps) => {
	const [isLoading] = useState(false);
	const [opened, { close, open }] = useDisclosure(false);

	const handleAction = (action: () => void) => {
		action();
		close();
	};

	return (
		<Popover
			shadow="md"
			opened={opened}
			// В контролируемом режиме клик мимо и Esc сообщают о закрытии только через onChange
			onChange={(value) => !value && close()}
			{...rest}
		>
			<Popover.Target>
				<Button onClick={open} loading={isLoading} {...button} />
			</Popover.Target>
			<Popover.Dropdown>
				<Stack>
					<Text size="md">{confirmText}</Text>
					<Group>
						<Button
							size="compact-sm"
							radius="sm"
							variant="outline"
							onClick={() => handleAction(onCancel)}
						>
							Нет
						</Button>
						<Button size="compact-sm" radius="sm" onClick={() => handleAction(onOk)}>
							Да
						</Button>
					</Group>
				</Stack>
			</Popover.Dropdown>
		</Popover>
	);
};
